import { getToken } from "./api";

// Decode the current admin's authUserId from the JWT payload (middle segment, base64url).
export function getCurrentAuthUserId(): string | null {
  try {
    const token = getToken();
    const segment = token?.split(".")[1];
    if (!segment) return null;
    const payload = JSON.parse(
      atob(segment.replace(/-/g, "+").replace(/_/g, "/")),
    );
    return (payload.authUserId as string) ?? null;
  } catch {
    return null;
  }
}
